import { useEffect, useState } from "react"
import { ReportsOptions } from "../Reports.type"

const reportSelectedHandler = () => {
    const getSelectedSection = () => {
        return sessionStorage.getItem("report_selected_section")
            ? JSON.parse(sessionStorage.getItem("report_selected_section") || "{}")
            : ReportsOptions.habs
    }
    const [selectedSection, setgetSelectedSection] = useState<{
        title: string
        value: string
    }>(getSelectedSection())

    useEffect(() => {
        setgetSelectedSection(getSelectedSection())
    }, [])

    const setSelectedSection = (v: { title: string; value: string }) => {
        sessionStorage.setItem("report_selected_section", JSON.stringify(v))
        setgetSelectedSection(getSelectedSection())
    }
    return { setSelectedSection, selectedSection }
}

export default reportSelectedHandler
